import { IncomeTypeCreateModal, IncomeTypeDeleteModal, IncomeTypeUpdateModal } from "modules/finances/features";
import React, { CSSProperties } from "react";
import { api, IncomeTypeDto } from "shared/api";
import { Modals } from "shared/lib";
import { Button, Fieldset, Icons, Menu, MenuButton, MenuContainer, MenuItem, Table } from "shared/ui";

export interface IIncomeTypeList {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const IncomeTypeList = (props: IIncomeTypeList) => {
  const incomeTypeList = api.incomeType.useIncomeTypeList(props.companySlug);

  const onCreate = () => {
    Modals.open(IncomeTypeCreateModal, { companySlug: props.companySlug });
  };

  const onUpdate = (data: IncomeTypeDto) => {
    Modals.open(IncomeTypeUpdateModal, { data, companySlug: props.companySlug });
  };

  const onDelete = (data: IncomeTypeDto) => {
    Modals.open(IncomeTypeDeleteModal, { data, companySlug: props.companySlug });
  };

  return (
    <Fieldset className={props.className} style={props.style} htmlId={props.htmlId}>
      <Fieldset.Content>
        <Fieldset.Title>Типы доходов</Fieldset.Title>
        <Fieldset.Subtitle>
          Типы доходов используются в&nbsp;планах на&nbsp;месяц. Лишние типы доходов можно удалять. Если удалить тип
          дохода, он&nbsp;не&nbsp;исчезнет из&nbsp;текущих планов на&nbsp;месяц.
        </Fieldset.Subtitle>

        <Table
          type="plain"
          columns={[
            { header: "", accessor: "name" },
            { header: "", accessor: "actions", align: "right" },
          ]}
          data={incomeTypeList.data?.map((it) => ({
            id: it.id,
            name: it.name,
            actions: (
              <MenuContainer>
                <MenuButton svgOnly size="small" variant="ghost" style={{ marginLeft: "auto" }}>
                  <Icons.DotsVertical />
                </MenuButton>
                <Menu minWidth={150}>
                  <MenuItem onClick={() => onUpdate(it)}>Редактировать</MenuItem>
                  <MenuItem type="error" onClick={() => onDelete(it)}>
                    Удалить
                  </MenuItem>
                </Menu>
              </MenuContainer>
            ),
          }))}
          header={false}
        />
      </Fieldset.Content>
      <Fieldset.Footer>
        <Fieldset.Footer.Status></Fieldset.Footer.Status>
        <Fieldset.Footer.Actions>
          <Button size="small" onClick={onCreate}>
            Добавить
          </Button>
        </Fieldset.Footer.Actions>
      </Fieldset.Footer>
    </Fieldset>
  );
};

IncomeTypeList.defaultProps = {};
